import { Box, Paper } from "@mui/material";
import { WaveSpecSlider } from "./WaveSpecSlider";
import { ZoomSlider } from "./ZoomSlider";
import { TransportControls } from "./TransportControls";
import { VolumeSlider } from "./VolumeSlider";
import { useEditorPreferences } from "../../store/editor/hooks";

const AudioControls = ({ wavesurfer, preferencesSave, onNext, onPrevious }) => {
  const { preferences, updateWaveOpacity, updateZoom } = useEditorPreferences();
  const waveOpacity = preferences.waveOpacity;
  const zoomAmount = preferences.zoomAmount;

  const onWaveSliderChange = (value) => {
    updateWaveOpacity(value);
    preferencesSave({ waveOpacity: value });
  };

  const onZoomChange = (value) => {
    updateZoom(value);
    preferencesSave({ zoomAmount: value });
  };

  const onVolumeChange = (value) => {
    wavesurfer.setVolume(value / 100);
  };

  const onJumpBack = () => {
    const newTime = wavesurfer.getCurrentTime() - 6;
    newTime < 0 ? wavesurfer.setTime(0) : wavesurfer.setTime(newTime);
  };

  const onJumpForward = () => {
    const newTime = wavesurfer.getCurrentTime() + 6;
    newTime > wavesurfer.getDuration()
      ? wavesurfer.setTime(wavesurfer.getDuration())
      : wavesurfer.setTime(newTime);
  };

  return (
    <Paper
      elevation={4}
      sx={{
        display: "flex",
        px: { xs: 1, lg: 10 },
      }}
    >
      <Box
        display="flex"
        justifyContent="flex-start"
        flex={1}
        sx={{ gap: { xs: 1, lg: 5 } }}
      >
        <WaveSpecSlider value={waveOpacity} onChange={onWaveSliderChange} />
        <ZoomSlider value={zoomAmount} onChange={onZoomChange} />
      </Box>
      <Box display="flex" justifyContent="center" flex={1}>
        <TransportControls
          wavesurfer={wavesurfer}
          onPause={() => wavesurfer.pause()}
          onStop={() => wavesurfer.stop()}
          onPlay={() => wavesurfer.play()}
          onJumpBack={onJumpBack}
          onJumpForward={onJumpForward}
          onNext={onNext}
          onPrev={onPrevious}
        />
      </Box>
      <Box display="flex" justifyContent="center" flex={1}>
        <VolumeSlider
          value={wavesurfer ? wavesurfer.getVolume() * 100 : 100}
          onChange={onVolumeChange}
        />
      </Box>
    </Paper>
  );
};

export default AudioControls;
